// extracted by mini-css-extract-plugin
export default {"done":"WishBoxSent_done__2RqI6","doneMark":"WishBoxSent_doneMark__E7+R0","title":"WishBoxSent_title__X+DB8","text":"WishBoxSent_text__N3yqz"};